/** @format */

import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { serverErrorCodeConfig } from 'src/config';
import { useAuth } from './use-auth';
import { useRouter } from './use-router';
import { has } from 'lodash';
import { get } from 'lodash';
import { isString } from 'lodash';
import { isArray } from 'lodash';

export function useServerError() {
  const { signOut } = useAuth();
  const router = useRouter();

  const processError = useCallback(
    async (error) => {
      console.log('error', error);
      try {
        let errorMessage = null;
        let errorCode = null;
        if (has(error, 'data') && has(error, 'status')) {
          console.log('1');
          const message = get(error.data, 'message');
          errorCode = get(error.data, 'error');
          if (isString(message)) {
            errorMessage = message;
          }
          if (isArray(message)) {
            errorMessage = get(message, '0', '');
          }
        }

        if (has(error, 'code') && has(error, 'name')) {
          console.log('2');
          errorCode = get(error, 'code');
          if (error.code === serverErrorCodeConfig.permissionDenied) {
            errorMessage = `Tài khoản này đã được đăng nhập trên thiết bị khác.`;
          } else {
            errorMessage = `${error.name}: ${error.message}`;
          }
        }

        if (has(error, 'status') && has(error, 'error')) {
          errorMessage = `${error.status}: ${error.error}`;
        }

        if (errorMessage) {
          toast.error(errorMessage);
        }

        if (errorCode === serverErrorCodeConfig.permissionDenied) {
          await signOut();
        }
      } catch (err) {
        console.error(err);
        toast.error('Có lỗi xảy ra!');
      }
    },
    [signOut, router]
  );

  return {
    processError
  };
}
